import Vue from 'vue'
import Vuex from 'vuex'
import { request } from '@/utils/request'
Vue.use(Vuex)

const state = {
  isDesktop: true,
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
}

const mutations = {
  SET_DEVICE(state, value) {
    state.isDesktop = value
  },
  setUserInfo(state, info) {
    state.userInfo = info
  },
}

const actions = {
  getUserInfo({ commit }) {
    return request({ method: 'get', url: '/general/auth/getUserInfo' }).then((res) => {
      console.log(res)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
      commit('setUserInfo', res.data)
    })
  },
  logout({ commit }) {
    return request({ method: 'get', url: '/general/access/logout' }).then(() => {
      localStorage.removeItem('userInfo')
      commit('setUserInfo', {})
    })
  },
  resize(context) {
    if (window.innerWidth > 768) {
      context.commit('SET_DEVICE', true)
    } else {
      context.commit('SET_DEVICE', false)
    }
  },
}

const getters = {
  isLogin(state) {
    return !!state.userInfo.nickname
  },
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {},
})
